<template>
    <div v-if="dateCancel">
        <div class="container my-5" v-if="showForm">
            <div class="col-lg-6 col-12 div-user mb-5">
                <legend>{{ translate.titleCancel }}</legend>
                <span class="subtitle">{{ translate.subtitleCancel }}</span>
                <div class="row my-5">
                    <ul>
                        <li class="d-flex flex-row">
                            <img :src="imgIcone" alt="Icone BDS" />
                            <span> {{ translate.infoCancel1 || '' }} <strong>{{ dateCancel.finish ?? '' }}.</strong></span>
                        </li>
                        <li class="d-flex flex-row mt-3">
                            <img :src="imgIcone" alt="Icone BDS" />
                            <span>{{ translate.infoCancel2 || '' }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-5 col-12 div-user">
                <div class="row d-flex justify-content-center align-items-center">
                    <span class="title-option mt-4 mb-3">{{ translate.labelOptionCancel }}</span>
                    <div class="col-lg-12 col-12 mb-3" v-for="(item, index) in translate.listMotivosCancel" :key="index">
                        <input type="checkbox" name="reasonCancel" :value="index" v-model="form.checkedItem"
                            @change="checkReason()" />
                        <label for="checkbox">{{ item }}</label>
                    </div>
                    <div class="mb-3">
                        <textarea rows="3" class="form-control" v-model="form.additions"
                            :placeholder="translate.placeholderMessage"></textarea>
                    </div>
                </div>
                <div class="col-6 mt-3">
                    <button class="button" type="submit" @click="sendCancel()">{{ translate.buttonLabelCancel }} <i
                            class="icon-arrow-right"></i></button>
                </div>
            </div>
        </div>
        <div v-else id="cancel-info">
            <div class="cancel-title text-center" v-html="translate.cancelAttention"></div>
            <div class="cancel-text text-center" v-html="translate.notCancelledYet"></div>
        </div>
    </div>
    <div v-else class="p-5 not-subscribe">
        {{ translate.notSubscribe }}
    </div>
</template>
  
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/myaccount'
import router from "router"
import IconeBds from 'assets/img/icone_BDS.png'
import api from '../../api'

export default defineComponent({
    name: 'FormCancel',
    props: ['dateCancel'],
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    data() {
        return {
            imgIcone: IconeBds,
            showForm: !this.$cookies.get('cancelOrder'),
            form: {
                locale: 'pt-br',
                checkedItem: [],
                additions: '',

            }
        }
    },
    methods: {
        checkReason() {
            if (this.form.checkedItem.includes(7)) {
                this.form.checkedItem = [7]
            } else {
                this.form.additions = ""
            }
        },
        sendCancel() {
            if (!this.form.checkedItem.length) {
                alert(this.translate.setReasonCancel)
                return false
            }
            if (this.form.checkedItem == 7 && this.form.additions == "") {
                alert(this.translate.setMessageReasonCancel)
                return false
            }
            window.scroll(0, 0)
            this.showForm = false
            this.form.locale = this.locale
            api.post('v1/myaccount/cancelOrder', this.form).then(({ data }) => {
                var days7 = 1000 * 60 * 60 * 24 * 7
                this.$cookies.set("cancelOrder", true, days7)
                if (data.returnStatus == "error") {
                    this.dateCancel = false
                }

            }).catch((error) => console.log(error))
        }
    }
})
</script>
  
<style scoped lang="css">
input[type=checkbox] {
    width: 30px;
}

input:checked {
    accent-color: black;
}

.img-alter-plan {
    margin: 20px 30px;
    width: 474px;
    height: 358px;
    object-fit: contain;
}

.title-option {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
}

ul>li>img {
    height: 18px;
    width: 16.46px;
    margin-right: 13px;
}

ul>li>span {
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 22px;
    color: #000;
    max-width: 520px;
}



label {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 23px;
    padding-inline: 16px;
}

div.col-6.div-user>div>div>span {
    font-family: 'Roboto-Regular';
    font-size: 13px;
    line-height: 15px;
    margin-right: 15px;
}

.form-check-input {
    --bs-form-check-bg: #fff;
    width: 2em;
    height: 2em;
    margin-top: 0px;
    margin-inline: 10px;
}

.form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #fff;
    font-size: small;
    max-width: 425px;
}

div.col-6.div-user>div>div.col-12>div>input.password {
    max-width: 287px;
}

.form-control:focus {
    color: #000;
    background-color: #f8f8f8;
}

legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
}

.subtitle {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 19px;
}

.black-title {
    color: #000;
    font-weight: bold;
    font-size: 26px;
    font-family: 'Exo-2';
    font-style: italic;
}

.subtitle span {
    font-size: 16px;
    font-weight: bold;
}


.label {
    display: flex;
    align-items: center;
    justify-content: center;
}

.d-w-btn {
    color: #fff;
    padding: 17px 100px;
    background: #000;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: larger;
    font-weight: 700;
    font-family: 'Exo-2';
}

.form-control {
    margin-top: 12px;
    background-color: #fff;
    color: #868686;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Exo-2';
}

.div-user {
    margin-left: 16px;
}

.cancel-title {
    margin-top: 30px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.cancel-text {
    margin-top: 20px;
    margin-bottom: 50px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 19px;
}

.not-subscribe {
    font-family: 'Roboto-Medium';
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-user {
        width: 100%;
    }

    legend {
        font-size: 18px;
    }

    .title-option {
        margin-top: 0px !important;
    }

    .img-alter-plan {
        display: none;
    }

}</style>
  